import { useQuery } from "@tanstack/react-query";
import { getMedicalRecordRequests } from "../../api/medical-record-requests.api";
import { MedicalRecordRequest } from "../../api/medical-record-requests.type";

const queryKey = ["medical-record-requests"] as const;

export function useMedicalRecordRequests() {
  return useQuery<MedicalRecordRequest[]>({
    queryKey,
    queryFn: getMedicalRecordRequests,
    staleTime: 30_000,
  });
}

export function medicalRecordRequestsQueryKey() {
  return queryKey;
}

export default useMedicalRecordRequests;
